import { defineComponent } from "vue";
import SvgIcon from "./SvgIcon.vue.mjs";
import { useBasicStore } from "../../../stores/basic.mjs";
import ArrowStrokeBackIcon from "../icons/ArrowStrokeBackIcon.vue.mjs";
import "../../../directives/vTap.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PopUpH5",
  props: {
    title: null
  },
  setup(__props) {
    const basicStore = useBasicStore();
    function handleClose() {
      basicStore.setSidebarOpenStatus(false);
      basicStore.setSidebarName("");
    }
    return { __sfc: true, basicStore, handleClose, SvgIcon, ArrowStrokeBackIcon };
  }
});
export {
  _sfc_main as default
};
